export default "/images/a67055cd7ca9e602100664efcb41ba0b.avif";